<script setup lang="ts">
defineProps<{
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  showLogo?: boolean;
}>();

const logoUrl = 'https://opticacroma.com.ar/wp-content/uploads/2024/05/croma-logo-1-e1715382202765.png';
</script>

<template>
  <div 
    :class="[
      'flex items-center justify-center',
      fullScreen && 'fixed inset-0 bg-white/80 backdrop-blur-sm z-50'
    ]"
  >
    <div class="flex flex-col items-center gap-4">
      <img 
        v-if="showLogo"
        :src="logoUrl" 
        alt="Óptica Croma Logo" 
        class="h-16 w-auto animate-pulse"
      />
      <div 
        :class="[
          'animate-spin rounded-full border-t-2 border-indigo-500',
          size === 'sm' && 'w-6 h-6 border-2',
          size === 'md' && 'w-8 h-8 border-2',
          size === 'lg' && 'w-12 h-12 border-3',
          !size && 'w-8 h-8 border-2'
        ]"
      />
    </div>
  </div>
</template>